export const actionTypes = {
  LOAD_CONFIGURATIONS: "LOAD_CONFIGURATIONS",
  LOAD_CONFIGURATIONS_SUCCESS: "LOAD_CONFIGURATIONS_SUCCESS",
  LOAD_CONFIGURATIONS_FAILURE: "LOAD_CONFIGURATIONS_FAILURE",
};

export const loadConfigurationsAction = () => ({
  type: actionTypes.LOAD_CONFIGURATIONS,
});

export const loadConfigurationsActionSuccess = (payload: any) => ({
  type: actionTypes.LOAD_CONFIGURATIONS_SUCCESS,
  payload,
});

export const loadConfigurationsActionFailure = (error: any) => ({
  type: actionTypes.LOAD_CONFIGURATIONS_FAILURE,
  error,
});
